export default "__VITE_ASSET__BdYPp938__"